// extracted by mini-css-extract-plugin
export var overlay = "ModalDialog-module--overlay--3rJhV";
export var open = "ModalDialog-module--open--z77ub";
export var closeOverlay = "ModalDialog-module--close-overlay--10KOH";
export var close = "ModalDialog-module--close--2QRn8";
export var dialog = "ModalDialog-module--dialog--3fVLC";
export var header = "ModalDialog-module--header--3Wp5i";
export var content = "ModalDialog-module--content--3OCAa";
export var actions = "ModalDialog-module--actions--32AO5";